// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3U0ue","left":"left___2K89R","right":"right___1egsm","center":"center___2e0X_"};